var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('page-header',{attrs:{"header":_vm.$t('start-guide.title')}}),_c('div',{staticClass:"content"},[_c('b-row',[_c('b-col',[_c('b-card',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content_html)}})])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }